import { render, staticRenderFns } from "./CopyStakeGameProvidersView.vue?vue&type=template&id=439d3889&scoped=true&lang=pug"
import script from "./CopyStakeGameProvidersView.vue?vue&type=script&lang=ts"
export * from "./CopyStakeGameProvidersView.vue?vue&type=script&lang=ts"
import style0 from "./CopyStakeGameProvidersView.vue?vue&type=style&index=0&id=439d3889&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439d3889",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardTitle,VContainer,VIcon})
